import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AppearanceSettingsForm: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography variant="h6" sx={{ mb: 0.5, fontSize: '1rem', fontWeight: 600 }}>
        ライブラリUI
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
        新しいダッシュボード型ライブラリを試すことができます（実験的）。
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {[
          { label: 'V1（デフォルト）', desc: '従来のプロフィール内ライブラリ', path: '/profile' },
          { label: 'V2（実験的）', desc: 'サイドバー型ダッシュボード', path: '/library' },
        ].map((opt) => (
          <Box
            key={opt.path}
            onClick={() => navigate(opt.path)}
            sx={{
              flex: 1,
              p: 2,
              borderRadius: '10px',
              border: '1px solid rgba(255,255,255,0.08)',
              backgroundColor: 'rgba(255,255,255,0.02)',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: 'rgba(255,255,255,0.15)',
                backgroundColor: 'rgba(255,255,255,0.04)',
              },
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', mb: 0.5 }}>
              {opt.label}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {opt.desc}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AppearanceSettingsForm;
